import {
  AccessibilityWidgetAriaLive,
  AccessibilityWidgetRole,
  Action,
  OperationType,
  Position,
  Stop
} from '../../dispatcher/Types';
import {
  ASYNC_DOWNLOAD_DISPATCHER_PREFIX,
  DOWNLOAD_INDICATOR_WIDGET
} from '../../dispatcher/config/Constants';
import Content from '../../dispatcher/modules/widget/download/Content';

export const FadeOutDownloadWidget: Action = [{
  args: ['downloadId'],
  delay: 3000,
  synchronous: true,
  moduleId: DOWNLOAD_INDICATOR_WIDGET,
  moduleName: 'DownloadWidget',
  name: 'widgetFadeOut'
}];

export const DownloadIndicatorWidget: Action = [{
  accessibility: {
    ariaLive: AccessibilityWidgetAriaLive.polite,
    role: AccessibilityWidgetRole.status
  },
  children: [{
    render: Content
  }],
  className: 'sm download-indicator',
  items: [{
    operations: [{
      args: ['downloadId'],
      moduleId: DOWNLOAD_INDICATOR_WIDGET,
      moduleName: 'DownloadWidget',
      name: 'widgetFadeOut'
    }],
    btnName: 'DownloadIndicator.cancel',
    btnConfig: {
      pos: Position.end,
      fillMode: 'flat',
      hidden: true
    },
    close: false
  }],
  title: 'DownloadIndicator.title',
  width: 300,
  height: 90,
  resizable: false,
  name: DOWNLOAD_INDICATOR_WIDGET,
  type: OperationType.widget
}];

export const closeAndUnlinkDownloadIndicatorWidget: Action = [{
  data: {
    moduleId: DOWNLOAD_INDICATOR_WIDGET
  },
  moduleName: 'DownloadWidget',
  name: 'close',
  executeType: 'visible'
}, {
  independent: true,
  dispatcherIds: [ASYNC_DOWNLOAD_DISPATCHER_PREFIX],
  partialMatch: true,
  type: OperationType.unlink
}, {
  independent: true,
  items: [Stop.stacks, Stop.operations],
  dispatcherIds: [ASYNC_DOWNLOAD_DISPATCHER_PREFIX],
  partialMatch: true,
  type: OperationType.stopAll
}];
